import { Dialog } from '@headlessui/react'


const WideViewModal = ({isOpen, setIsOpen, size, zIndex, wideViewControl, wideViewClassName, dialogPanelClassName, children }) => {
    
    return (
        <Dialog open={isOpen} onClose={setIsOpen} className={`relative ${zIndex ? zIndex : "z-50"}`}>
            <div className={`fixed inset-0 bg-black/40`} aria-hidden="true" />
            <div className="fixed inset-0 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center py-8">
                    <Dialog.Panel className={`w-full mx-auto ${wideViewControl ? wideViewClassName : `max-w-${size}`} bg-white rounded-xl shadow-xl max-h-[600px] overflow-y-scrolls ${dialogPanelClassName}`}>
                        <div className='p-7'>
                            {children}
                        </div>
                    </Dialog.Panel>
                </div>
            </div>
        </Dialog>
    )
}

export default WideViewModal